import React from 'react';
import { Avatar, Paper, withStyles } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';

const styles = theme => ({
  card: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(6),
    backgroundColor: theme.palette.grey[100],
    height: '100%',
    borderRadius: '15px'
  },
  avatar: {
    backgroundColor: "#1e5abb",
    width: theme.spacing(8),
    height: theme.spacing(8),
    marginBottom: theme.spacing(2),
    alignSelf: 'center',
    fontSize: theme.spacing(4),
  },
  typography: {
    alignSelf: 'center'
  },
  typographyText: {
    alignSelf: 'center',
    color: theme.palette.grey[700],
    fontWeight: "500",
  },
});

const LandingCard = (props) => {
  const {classes, icon, header, children } = props;
  return (
    <Paper className={classes.card} elevation={0}>
      <Avatar className={classes.avatar}>
        {icon}
      </Avatar>
      <Typography className={classes.typography} variant='h5' paragraph>
        {header}
      </Typography>
      <Typography className={classes.typographyText}>
        {children}
      </Typography>
    </Paper>
  )
}

export default withStyles(styles)(LandingCard)
